import { Link } from 'react-router-dom';
import { useLang } from '../i18n/context';
import SEO from '../components/SEO';
import { Container, Reveal } from '../components/Reveal';
import FAQ from '../components/FAQ';
import { WhatsAppButton } from '../components/CTAs';
import { breadcrumbSchema } from '../lib/schema';
import { TEEN } from '../data/teen';

export default function TeenSmile() {
    const { t, lang } = useLang();
    const c = TEEN[lang] || TEEN.en;
    return (
        <>
            <SEO
                title={c.metaTitle}
                description={c.metaDesc}
                path="/teen-smile"
                lang={lang}
                jsonLd={[
                    breadcrumbSchema(lang, [
                        { name: t.nav.home, path: '/' },
                        { name: t.nav.teen, path: '/teen-smile' },
                    ]),
                ]}
            />
            <section className="relative overflow-hidden pt-28 md:pt-36">
                <div className="pointer-events-none absolute -right-32 -top-20 h-96 w-96 rounded-full bg-peri-200/70" aria-hidden="true" />
                <Container className="relative">
                    <Reveal>
                        <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-gold-700">{t.nav.teen}</p>
                        <h1 className="mt-4 max-w-3xl font-serif text-4xl font-semibold leading-tight tracking-tight text-ink md:text-6xl">{c.title}</h1>
                        <p className="mt-2 font-serif text-2xl italic text-gold-700">{c.subtitle}</p>
                        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-muted">{c.heroText}</p>
                    </Reveal>
                </Container>
            </section>

            <section className="py-16 md:py-24" data-testid="teen-questions">
                <Container>
                    <Reveal>
                        <h2 className="mb-8 font-serif text-2xl font-semibold text-ink md:text-3xl">{t.treatLabels.faq}</h2>
                        <FAQ faqs={c.questions} testPrefix="teen-faq" />
                    </Reveal>
                </Container>
            </section>

            <section className="bg-peri-50 py-16 md:py-24" data-testid="teen-cta-section">
                <Container>
                    <Reveal>
                        <div className="rounded-3xl border border-peri-200 bg-white p-8 md:p-12">
                            <div className="grid items-center gap-8 lg:grid-cols-[1fr_auto]">
                                <div>
                                    <h2 className="font-serif text-3xl font-semibold text-ink md:text-4xl">{c.ctaTitle}</h2>
                                    <p className="mt-4 max-w-2xl text-base leading-relaxed text-ink-muted">{c.ctaText}</p>
                                </div>
                                <WhatsAppButton label={t.cta.whatsappLong} source="teen-page" testId="teen-whatsapp-cta" />
                            </div>
                            <div className="mt-10 flex flex-wrap gap-3 border-t border-peri-100 pt-8">
                                <Link to={`/dental/${lang}/treatments/conventional-braces`} className="rounded-full border border-peri-300 px-5 py-2.5 text-sm font-semibold text-gold-700 hover:bg-peri-50">{t.nav.treatmentsMenu[0].title}</Link>
                                <Link to={`/dental/${lang}/treatments/clear-aligners`} className="rounded-full border border-peri-300 px-5 py-2.5 text-sm font-semibold text-gold-700 hover:bg-peri-50">{t.nav.treatmentsMenu[1].title}</Link>
                                <Link to={`/dental/${lang}/kolum`} className="rounded-full border border-peri-300 px-5 py-2.5 text-sm font-semibold text-gold-700 hover:bg-peri-50">{t.nav.kolum}</Link>
                            </div>
                        </div>
                    </Reveal>
                </Container>
            </section>
        </>
    );
}
